import { Tag } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { invoiceStatusToTagColor } from '@features/invoicesLegacy/constants/invoiceStatusToTagColor'
import { invoiceStatusToTitleKey } from '@features/invoicesLegacy/constants/invoiceStatusToTitleKey'
import { InvoiceStatus } from '@features/invoicesLegacy/enums/invoiceStatus'

interface InvoicePaymentPanePrefixProps {
  status: InvoiceStatus
}

export const InvoicePaymentPanePrefix = ({ status }: InvoicePaymentPanePrefixProps): ReactElement => {
  const { t } = useTranslation()

  const tagColor = invoiceStatusToTagColor[status]
  const tagLabel = t(invoiceStatusToTitleKey[status])

  return (
    <Tag color={tagColor} type="subtle">
      {tagLabel}
    </Tag>
  )
}
